/* eslint-disable no-unused-vars */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommuniquesPageComponent } from './pages';

const routes: Routes = [
  {
    path: '',
    component: CommuniquesPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommuniquesRoutingModule {}
